import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class SubscriberGate extends BaseOption {
  static optionKey = "subscriber-gate";

  static userInterfaceComponent = {
    label: "Only show to non-subscribers",
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          label: "Yes",
          value: "yes",
        },
        {
          label: "No",
          value: "no",
        },
      ],
    },
  };

  static defaultValue = "no";

  static convertConfigValueToCompiledValue(configValue) {
    return configValue === "yes";
  }
}
